import Vue from 'vue';
import Vuex from 'vuex';
import main from './main';
import financial from '@/views/reconciliation/store';
import userLogin from '@/views/login/store';
import apply from '@/views/apply/store';
import setup from '@/views/set-up/store';
import trading from '@/views/trading/store';
import statistics from '@/views/statistics/store';
import merchants from '@/views/merchants/store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    main,
    ...financial,
    ...userLogin,
    ...apply,
    ...setup,
    ...trading,
    ...statistics,
    ...merchants
  },
});